import React, { useState } from "react";
import ContactImg from "../assets/contact.png";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [isSent, setIsSent] = useState(false);

  const submit = (e) => {
    e.preventDefault(); // Prevent form reload
    setIsSent(true);
    setTimeout(() => setIsSent(false), 3000); // Remove the success label after 3 seconds

    // Clear form fields
    setName("");
    setEmail("");
    setPhone("");
    setSubject("");
    setMessage("");
  };

  return (
    <section
      id="contact"
      className="py-24 mt-10 p-5 bg-gradient-to-b to-gray-900 from-black text-white"
    >
      <div className="container mx-auto">
        <h2 className="text-5xl md:text-6xl font-bold text-center text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600 mb-12 animate__animated animate__fadeInUp">
          Contact Me
        </h2>
        <div className="flex flex-col lg:flex-row items-center justify-center gap-8">
          {/* Left Side - Image or Illustration */}
          <div className="w-full lg:w-1/2 flex justify-center">
            <div className="relative w-full max-w-xl">
              <img
                src={ContactImg}
                alt="Contact Illustration"
                className="w-full rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-70 rounded-lg"></div>
            </div>
          </div>

          {/* Right Side - Contact Form */}
          <div className="w-full lg:w-1/2">
            <form
              className="bg-gray-800 bg-opacity-50 backdrop-blur-md p-8 rounded-2xl shadow-2xl transform transition-all duration-500 hover:scale-105 hover:shadow-xl border border-gray-700"
              onSubmit={submit}
            >
              <input
                type="text"
                placeholder="Full Name"
                className="w-full p-4 mb-4 rounded-lg bg-gray-900 bg-opacity-70 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500 transition-all duration-300 ease-in-out hover:bg-opacity-80"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <input
                type="email"
                placeholder="Enter Your Email"
                className="w-full p-4 mb-4 rounded-lg bg-gray-900 bg-opacity-70 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500 transition-all duration-300 ease-in-out hover:bg-opacity-80"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                type="tel"
                placeholder="Phone Number"
                className="w-full p-4 mb-4 rounded-lg bg-gray-900 bg-opacity-70 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500 transition-all duration-300 ease-in-out hover:bg-opacity-80"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="Subject"
                className="w-full p-4 mb-4 rounded-lg bg-gray-900 bg-opacity-70 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500 transition-all duration-300 ease-in-out hover:bg-opacity-80"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
              />
              <textarea
                placeholder="Your Message"
                className="w-full p-4 mb-6 rounded-lg bg-gray-900 bg-opacity-70 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500 transition-all duration-300 ease-in-out hover:bg-opacity-80"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              ></textarea>
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 px-6 py-3 rounded-lg font-semibold text-gray-900 transition-all duration-300 ease-in-out transform hover:scale-105"
              >
                Send Message
              </button>
            </form>
            {isSent && (
              <p className="text-center text-green-400 mt-6 text-lg animate__animated animate__fadeInUp">
                Message sent successfully!
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
